import { gql } from '@apollo/client';

export const SAVE_MEMBER_ASSOCIATION = gql`
  mutation SaveMemberAssociation(
    $societyId: Int!
    $memberId: Int!
    $memberIdent: String!
  ) {
    saveMemberAssociation(
      societyId: $societyId
      memberId: $memberId
      memberIdent: $memberIdent
    ) {
      settingKey
      societyId
      memberId
      memberIdent
    }
  }
`;

export const DELETE_MEMBER_ASSOCIATION = gql`
  mutation DeleteMemberAssociation($settingKey: String!, $societyId: Int!) {
    deleteMemberAssociation(settingKey: $settingKey, societyId: $societyId)
  }
`;
